import { MdCheck } from "react-icons/md";
import { MdClear } from "react-icons/md";
import React, { useImperativeHandle } from "react";
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../fx/FxLog';
import { useStyles } from "./StylesCx";
import { makeStyles } from '@material-ui/core/styles';
import CxTooltip from './CxTooltip';
import { FormLabel, FormControlLabel, FormGroup, } from "@material-ui/core";
import CxIconButtonNew from "./CxIconButtonNew";

const useStylesLocal = makeStyles({
  ctl_label: {
    padding: '5px 0 8px 4px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    margin: '0px 0px 0px 0px',
    cursor: 'default',
    textAlign: 'left',
    //color: 'var(--ibs_color_gray)',
    fontSize: 'var(--ibs_control_label_font_size_radio)',
    "&.MuiFormControlLabel-root": {
      width: props => {
        if (props.width) {
          return props.width;
        } else {
          return '100%'
        }
      },
    },
  },

  ctl_group: {
    margin: '5px 12px 8px 12px',
    /* quitado porque los ítems rebasan el margen inferior
    height: props => {
      if (props.height) {
        return props.height;
      } else {
        return ''
      }
    },
    */
  },

  ctl_check: {
    "& .MuiTypography-body1": {
      textAlign: 'left',
      margin: '5px 0px 5px 2px',
      fontSize: props => { return props.fontSize || 'var(--ibs_control_label_font_size_radio)' },
      width: props => { return props.itemWidth || '100px' },
    },
  },
});


const CxMultiCheckNew = (props) => {
  const classes = useStyles(props);
  const classesL = useStylesLocal(props);
  const [list, setList] = React.useState(props.list || []);
  const [wasChanged, setChanged] = React.useState(false);
  const [visible, setVisible] = React.useState(props.visible==='false' ? false : true);

  const r_checked = React.useRef('');

  const rf_group = React.useRef('');
  const rf_check = React.useRef([]);

  // Efecto para la carga inicial de datos
  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);

  // NUEVO useEffect para manejar el marcado de checkboxes después de que la lista se ha cargado y renderizado
  React.useEffect(() => {
    // Asegurarse de que la lista tiene elementos y que las referencias están disponibles
    if (list.length > 0 && rf_check.current.length > 0) {
      doCheck();
    }
  }, [list]); // Dependencia de 'list'


  useImperativeHandle(props.xref, () => {
    return {
      getType, setVal, getVal, getLabel, getDbfield, isEmpty, wasChanged, setChanged, isVisible, setVisible, setList
    };
  });
  const getType = () => { return 'CxMultiCheckNew' };
  const setVal = (checkedPSV) => { setIdsChecked(checkedPSV) };
  const getVal = () => { return getIdsChecked() || '' };
  const getLabel = () => { return '' };
  const getDbfield = () => { return props.dbfield };
  const isEmpty = () => { return r_checked.current?.length === 0 };
  const isVisible = () => { return visible };

  /* Listado de ítems a checkear, separados por pipes. Ej: '000003.SRV|000001.SRV' */
  const doCheck = () => {
    // Asegurarse de que rf_check.current tenga elementos y no haya nulos
    // Esta verificación adicional es una buena práctica defensiva.
    if (!rf_check.current || rf_check.current.length === 0) {
        FxLog.infox('CxMultiCheckNew.doCheck', 'rf_check.current está vacío o no inicializado.');
        return;
    }

    for (let index = rf_check.current.length - 1; index >= 0; index--) {
      // Verificar si el elemento en la referencia es null antes de acceder a 'id'
      const element = rf_check.current[index];
      if (element && r_checked.current.includes(element.id)) {
        element.checked = true;
      }
    }
  };

  const setIdsChecked = (checkedPSV) => {
    r_checked.current = checkedPSV;
  };

  /* devuelve los id separados por pipes */
  const getIdsChecked = () => {
    let newValue = '';

    // Asegurarse de que rf_check.current tenga elementos y no haya nulos
    if (!rf_check.current || rf_check.current.length === 0) {
        return ''; // No hay checkboxes para obtener valores
    }

    for (let index = rf_check.current.length - 1; index >= 0; index--) {
      const ctl = rf_check.current[index];
      if (ctl && ctl.checked) { // Verificar si ctl no es null
        newValue += '|' + ctl.id;
      }
    }
    newValue = newValue.substring(1);


    setVal(newValue)
    setChanged(true);

    return newValue;
  };

  const doClear = () => {
    if (!rf_check.current || rf_check.current.length === 0) {
        return;
    }
    for (let index = rf_check.current.length - 1; index >= 0; index--) {
      const element = rf_check.current[index];
      if(element) { // Verificar si el elemento no es null
        element.checked = false;
      }
    }

    setVal('')
    setChanged(true);
  };

  const doCheckAll = () => {
    if (!rf_check.current || rf_check.current.length === 0) {
        return;
    }
    for (let index = rf_check.current.length - 1; index >= 0; index--) {
      const element = rf_check.current[index];
      if(element) { // Verificar si el elemento no es null
        element.checked = true;
      }
    }

    setVal('')
    setChanged(true);
  };

  return (
    <CxTooltip text={props.tooltip ? props.tooltip : null} tooltipType={props.tooltipType}>
      <div id='div_CxMultiCheckNew' className={classes.frame} style={{ display: visible ? '' : 'none' }}>
        <div className={classes.frame_content} style={{ padding: '0px', }}>
          <FormLabel component="legend" focused={false} classes={{ root: classesL.ctl_label, }} >
            {props.label}
          </FormLabel>
          <FormGroup ref={rf_group} row={true} classes={{ root: classesL.ctl_group, }}>
            {list.map((item, i) => (
              <FormControlLabel classes={{ root: classesL.ctl_check, }}
                key={item.id}
                label={item.name}
                control={
                  <label className="ibs_checkbox">
                    <input ref={(element) => rf_check.current[i] = element} type="checkbox"
                      id={item.id}
                      value={item.name}
                      defaultChecked={Boolean(item.checked === '1') || false}
                    />
                  </label>
                }
              />
            ))}
          </FormGroup>

        </div>
        {!props.hidebuttons && <div className={classes.frame_buttons}>
          {!props.readOnly && <CxIconButtonNew icon={<MdClear fontSize={20} />} classType={classes.frame_icons_new} onClick={doClear} disabled={props.disabled} />}
          {!props.readOnly && <CxIconButtonNew icon={<MdCheck fontSize={20} />} classType={classes.frame_icons_new} onClick={doCheckAll} disabled={props.disabled} />}
        </div>}
      </div>
    </CxTooltip>
  );

};

export default CxMultiCheckNew;